"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Label;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RequiredAsterisk = _interopRequireDefault(require("../../RequiredAsterisk"));

var _hiddenElement = _interopRequireDefault(require("../../Structural/hiddenElement"));

var _labelText = _interopRequireDefault(require("./labelText"));

function Label(props) {
  var label = props.label,
      required = props.required,
      inputId = props.inputId,
      readOnly = props.readOnly,
      id = props.id,
      hideLabel = props.hideLabel;

  if (hideLabel) {
    return _react["default"].createElement(_hiddenElement["default"], {
      as: "label",
      htmlFor: inputId,
      id: id
    }, _react["default"].createElement(_RequiredAsterisk["default"], {
      required: required
    }), label);
  }

  return _react["default"].createElement(_labelText["default"], {
    readOnly: readOnly,
    htmlFor: inputId,
    id: id
  }, _react["default"].createElement(_RequiredAsterisk["default"], {
    required: required
  }), label);
}

Label.propTypes = {
  label: _propTypes["default"].node,
  required: _propTypes["default"].bool,
  inputId: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  hideLabel: _propTypes["default"].bool
};
Label.defaultProps = {
  label: undefined,
  required: false,
  inputId: undefined,
  readOnly: false,
  id: undefined,
  hideLabel: false
};